import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError } from '../lib/api';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email }, { authenticated: false });
      setSubmitted(true);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Erreur inattendue');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-semibold text-neutral-900">Falko</h1>
          <p className="mt-2 text-sm text-neutral-500">Récupération du mot de passe</p>
        </div>

        {submitted ? (
          <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 text-center">
            <div className="text-3xl mb-2">📧</div>
            <h2 className="text-lg font-semibold text-neutral-900 mb-2">Vérifie ta boîte mail</h2>
            <p className="text-sm text-neutral-600 mb-4">
              Si un compte est associé à cet email, tu recevras un lien pour réinitialiser ton mot de
              passe dans quelques instants.
            </p>
            <p className="text-xs text-neutral-500">Le lien est valable 1 heure.</p>
          </div>
        ) : (
          <form
            onSubmit={onSubmit}
            className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 space-y-4"
          >
            <p className="text-sm text-neutral-600">
              Entre ton adresse email, on t'envoie un lien pour choisir un nouveau mot de passe.
            </p>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-neutral-700 mb-1">
                Adresse email
              </label>
              <input
                id="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
                placeholder="toi@exemple.com"
              />
            </div>
            {error && (
              <div className="rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full rounded-lg bg-violet-600 text-white py-2 text-sm font-medium hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
            >
              {isLoading ? 'Envoi…' : 'Envoyer le lien'}
            </button>
          </form>
        )}

        <p className="mt-6 text-center text-sm text-neutral-600">
          <Link to="/login" className="text-violet-600 hover:text-violet-700 font-medium">
            Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
};
